import { render, staticRenderFns } from "./DiseaseType.vue?vue&type=template&id=ab4377ba&scoped=true&"
import script from "./DiseaseType.vue?vue&type=script&lang=js&"
export * from "./DiseaseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4377ba",
  null
  
)

export default component.exports